(function () {
  const SELECTOR = "[data-kwl-footer-reviews]";

  function escapeHtml(value) {
    return String(value || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;");
  }

  function stars(rating) {
    const whole = Math.round(Number(rating) || 0);
    let html = "";
    for (let i = 1; i <= 5; i += 1) {
      html += i <= whole ? "&#9733;" : "&#9734;";
    }
    return html;
  }

  async function fetchSummary(root) {
    const endpoint = root.dataset.endpoint;
    const url = new URL("/v1/all-reviews", endpoint);
    url.searchParams.set("page", "1");
    url.searchParams.set("per_page", "1");

    const response = await fetch(url.toString());
    if (!response.ok) throw new Error("Failed to load footer reviews");
    return response.json();
  }

  function render(root, data) {
    const host = root.querySelector(".footer__reviews-card");
    if (!host) return;

    const score = Number(data.summary?.averageRating || 0).toFixed(1);
    const count = Number(data.summary?.reviewCount || 0);
    const reviewUrl = root.dataset.reviewUrl || "/pages/reviews";

    host.innerHTML = `
      <p class="footer__reviews-label">Customer reviews</p>
      <div class="footer__reviews-row">
        <div class="footer__reviews-head">
          <span class="footer__reviews-score">${escapeHtml(score)}</span>
          <div>
            <div class="footer__reviews-stars" aria-hidden="true">${stars(score)}</div>
            <p class="footer__reviews-count">${escapeHtml(count.toLocaleString())} reviews</p>
          </div>
        </div>
        <div class="footer__reviews-actions">
          <a class="button button--secondary footer__reviews-button" href="${escapeHtml(reviewUrl)}">See all reviews</a>
        </div>
      </div>
    `;
  }

  function renderError(root) {
    const host = root.querySelector(".footer__reviews-card");
    if (!host) return;

    host.innerHTML = `
      <p class="footer__reviews-label">Customer reviews</p>
      <div class="footer__reviews-row">
        <div class="footer__reviews-head">
          <span class="footer__reviews-score">4.8</span>
          <div>
            <div class="footer__reviews-stars" aria-hidden="true">${stars(4.8)}</div>
            <p class="footer__reviews-count">Browse recent customer feedback</p>
          </div>
        </div>
        <div class="footer__reviews-actions">
          <a class="button button--secondary footer__reviews-button" href="${escapeHtml(root.dataset.reviewUrl || "/pages/reviews")}">See all reviews</a>
        </div>
      </div>
    `;
  }

  function mount(root) {
    if (root.dataset.bound === "true") return;
    root.dataset.bound = "true";

    const observer = new IntersectionObserver(
      function (entries) {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          observer.disconnect();
          fetchSummary(root)
            .then(function (data) {
              render(root, data);
            })
            .catch(function (error) {
              console.error(error);
              renderError(root);
            });
          break;
        }
      },
      { rootMargin: "200px 0px" }
    );

    observer.observe(root);
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(mount);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
